<template>
  <div>
    <v-data-table
      :headers="customerRepairBomDataTableHeaders"
      :items="customerRepairBoms"
      class="elevation-1 ma-5 "
      :search="searchCustomerRepairBom"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :header-props="headerProps"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('customer_repair_item_toolbar_title') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchCustomerRepairBom"
            append-icon="mdi-magnify"
            :label="$t('customer_repair_item_search_label')"
            single-line
            hide-details
            clearable
          ></v-text-field>
          <v-btn
            v-if="viewName === 'update-many'"
            color="primary"
            :disabled="isAllTextFieldDisable"
            class="ml-5"
            @click="isShowEditCustomerRepairBomDialog = true"
          >
            {{ $t('common_new') }}
          </v-btn>
          <v-dialog v-model="isShowEditCustomerRepairBomDialog" fullscreen persistent>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ $t('common_edit') }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <ValidationObserver ref="repairItem">
                    <v-row>
                      <v-col cols="12" sm="6" md="4" lg="4" xl="4">
                        <ValidationProvider
                          name="Bom名稱"
                          rules="required"
                          v-slot="{ errors }"
                          v-if="editedCustomerRepairBomIndex === -1"
                        >
                          <v-autocomplete
                            :items="bomList"
                            item-text="Name"
                            item-value="Id"
                            return-object
                            v-model="editedCustomerRepairBom"
                            @change="setEditedCustomerRepairBom"
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              Bom名稱
                            </template>
                            <template v-slot:item="data">
                              <template>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    {{ data.item.Name }}
                                  </v-list-item-title>
                                  <v-list-item-subtitle>
                                    {{ data.item.Describe }}
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </template>
                          </v-autocomplete>
                        </ValidationProvider>
                        <ValidationProvider
                          name="Bom名稱"
                          rules="required"
                          v-slot="{ errors }"
                          v-else
                        >
                          <v-text-field
                            v-model="editedCustomerRepairBom.Name"
                            disabled
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              Bom名稱
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="4" xl="4">
                        <v-text-field
                          v-model="editedCustomerRepairBom.Describe"
                          label="Bom描述"
                          disabled
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="4" xl="4">
                        <ValidationProvider
                          name="Bom價格"
                          :rules="{ required: true, regex: /^[0-9]+$/ }"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedCustomerRepairBom.Price"
                            :error-messages="errors[0]"
                            label="Bom價格"
                          >
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <ValidationProvider name="變更原因" rules="required" v-slot="{ errors }">
                          <v-textarea
                            outlined
                            v-model="editedCustomerRepairBom.Reason"
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              變更原因
                            </template>
                          </v-textarea>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </ValidationObserver>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1"
                  text
                  @click="closeEditedCustomerRepairBom"
                  :disabled="isAllTextFieldDisable"
                >
                  {{ $t('common_cancel') }}
                </v-btn>
                <v-btn color="green darken-1" text @click="addEditedCustomerRepairBom">
                  {{ $t('common_confirm') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <delete-dialog
            :isAllTextFieldDisable="isAllTextFieldDisable"
            :isLoadingSaveBtn="isLoadingSaveBtn"
            :isShowDeleteDialog="isShowDeleteCustomerRepairBomDialog"
            :deleteMessage="'item_group_delete_dialog_message'"
            @closeDelete="closeCustomerRepairBom"
            @confirmDelete="confirmDeleteCustomerRepairBom"
          />
        </v-toolbar>
      </template>
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn
          icon
          @click="isShowEditCustomerRepairBomDialogBtn(item)"
          :disabled="isAllTextFieldDisable"
        >
          <v-icon small>
            mdi-pencil
          </v-icon>
        </v-btn>
        <v-btn
          icon
          @click="isShowDeleteCustomerRepairBomDialogBtn(item)"
          :disabled="isAllTextFieldDisable"
        >
          <v-icon small>
            mdi-delete
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { HttpBom } from '@/js/http-Manager'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { OriginalType } from '@/js/OriginalType'
export default {
  components: { DeleteDialog },
  name: 'UpdateCustomerRepairBom',
  props: {
    customerId: {
      type: String
    },
    customerRepairBoms: {
      type: Array
    },
    isAllTextFieldDisable: {
      type: Boolean,
      default: false
    },
    viewName: {
      type: String
    }
  },
  data: () => ({
    searchCustomerRepairBom: '',
    isLoadingBom: false,
    isLoadingSaveBtn: false,
    bomList: [],
    editedCustomerRepairBom: {
      BomId: '',
      Description: '',
      Name: '',
      Price: 0,
      Reason: '',
      CustomerRepairBomItems: []
    },
    defaultCustomerRepairBom: {
      BomId: '',
      Description: '',
      Name: '',
      Price: 0,
      Reason: '',
      CustomerRepairBomItems: []
    },
    isShowEditCustomerRepairBomDialog: false,
    isShowDeleteCustomerRepairBomDialog: false,
    editedCustomerRepairBomIndex: -1,
    editedCustomerRepairBomItemIndex: -1
  }),
  async mounted () {
    await this.getAllBoms()
  },
  watch: {},
  computed: {
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    customerRepairBomDataTableHeaders () {
      return [
        { text: 'BOM名稱', align: 'start', value: 'Name' },
        { text: 'BOM描述', align: 'start', value: 'Describe' },
        { text: 'BOM價格', align: 'start', value: 'Price' },
        { text: '變更原因', align: 'start', value: 'Reason' },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false }
      ]
    }
  },
  methods: {
    async setEditedCustomerRepairBom () {
      if (this.editedCustomerRepairBom) {
        this.editedCustomerRepairBom.BomId = this.editedCustomerRepairBom.Id
        this.editedCustomerRepairBom = JSON.parse(JSON.stringify(this.editedCustomerRepairBom))
      } else {
        this.editedCustomerRepairBom = JSON.parse(JSON.stringify(this.defaultCustomerRepairBom))
      }
    },
    convertOriginalType (originalType) {
      return OriginalType.getOriginalTypeName(originalType)
    },
    async getAllBoms () {
      this.isLoadingBom = true
      let response = await HttpBom.GetAllBoms()
      this.bomList = response && response.status === 200 ? response.data.Data : []
      this.isLoadingBom = false
    },
    isShowEditCustomerRepairBomDialogBtn (item) {
      this.editedCustomerRepairBomIndex = this.customerRepairBoms.indexOf(item)
      this.editedCustomerRepairBom = JSON.parse(JSON.stringify(item))
      this.isShowEditCustomerRepairBomDialog = true
    },
    isShowDeleteCustomerRepairBomDialogBtn (item) {
      this.editedCustomerRepairBomIndex = this.customerRepairBoms.indexOf(item)
      this.isShowDeleteCustomerRepairBomDialog = true
    },
    closeEditedCustomerRepairBom () {
      this.isShowEditCustomerRepairBomDialog = false
      this.editedCustomerRepairBomIndex = -1
      this.editedCustomerRepairBom = JSON.parse(JSON.stringify(this.defaultCustomerRepairBom))
    },
    async addEditedCustomerRepairBom () {
      const isValid = await this.$refs.repairItem.validate()
      if (isValid) {
        this.$emit('setEditedCustomerRepairBomIndex', this.editedCustomerRepairBomIndex)
        this.$emit('addEditedCustomerRepairBom', this.editedCustomerRepairBom)
        this.closeEditedCustomerRepairBom()
      }
    },
    confirmDeleteCustomerRepairBom () {
      this.$emit('confirmDeleteCustomerRepairBom', this.editedCustomerRepairBomIndex)
      this.closeCustomerRepairBom()
    },
    closeCustomerRepairBom () {
      this.editedCustomerRepairBomIndex = -1
      this.isShowDeleteCustomerRepairBomDialog = false
    }
  }
}
</script>
